import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

type BackButtonProps = {
	label?: string;
	fallbackPath?: string;
	className?: string;
	size?: 'sm' | 'md';
	forceFallback?: boolean;
};

export default function BackButton({
	label = 'Back',
	fallbackPath = '/',
	className = '',
	size = 'md',
	forceFallback = false
}: BackButtonProps) {
	const navigate = useNavigate();

	const handleClick = useCallback(() => {
		if (!forceFallback && typeof window !== 'undefined' && window.history.length > 1) {
			navigate(-1);
		} else {
			navigate(fallbackPath);
		}
	}, [navigate, fallbackPath, forceFallback]);

	const sizeClass = size === 'sm' ? 'btn-sm' : '';

	return (
		<button
			type="button"
			className={`btn btn-outline-secondary ${sizeClass} d-inline-flex align-items-center gap-2 ${className}`.trim()}
			onClick={handleClick}
		>
			<i className="bi bi-arrow-left"></i>
			<span>{label}</span>
		</button>
	);
}
